// @flow
import React from "react";
import { Form } from "react-bootstrap";
import * as layoutConstants from "../../data/layout";

/**
 * Componente para el ancho del tema
 *
 * @param {Object} props - Propiedades del componente
 * @param {Function} props.changeWidthMode - Función para cambiar el ancho del tema
 * @param {String} props.layoutWidth - Ancho del tema
 * @param {Object} props.layoutConstants - Constantes de ancho del tema
 * @returns {JSX.Element} Componente de React
 */
const LayoutWidth = ({ changeWidthMode, layoutWidth, layoutConstants }) => {
  return (
    <>
      <h5 className="mt-4">Ancho del Tema</h5>

      <hr className="mt-1" />

      <Form.Check className="form-check form-switch mb-1">
        <Form.Check.Input
          type="radio"
          name="width"
          id="fluid-check"
          value={layoutConstants.LAYOUT_WIDTH_FLUID}
          onChange={(e) => changeWidthMode(e.target.value)}
          checked={layoutWidth === layoutConstants.LAYOUT_WIDTH_FLUID}
        />
        <Form.Check.Label htmlFor="fluid-check">Flexible</Form.Check.Label>
      </Form.Check>

      <Form.Check className="form-check form-switch mb-1">
        <Form.Check.Input
          type="radio"
          name="width"
          id="boxed-check"
          value={layoutConstants.LAYOUT_WIDTH_BOXED}
          onChange={(e) => changeWidthMode(e.target.value)}
          checked={layoutWidth === layoutConstants.LAYOUT_WIDTH_BOXED}
        />
        <Form.Check.Label htmlFor="boxed-check">En caja</Form.Check.Label>
      </Form.Check>
    </>
  );
};

export default LayoutWidth;
